document.addEventListener('DOMContentLoaded', () => {
  const banner = document.querySelector('.cookies')
  if (!banner) return

  const closeBtn = banner.querySelector('button')
  const COOKIE_NAME = 'kova_cookie_consent'
  const SIX_MONTHS_SECONDS = 15724800 // ~182 days

  const getCookie = (name) =>
    document.cookie.split('; ').find((r) => r.startsWith(name + '='))?.split('=')[1]

  const setCookie = (name, value, maxAgeSeconds) => {
    const base = `${name}=${value}; Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax`
    const secure = location.protocol === 'https:' ? '; Secure' : ''
    document.cookie = base + secure
  }

  const setInert = (el, value) => {
    try {
      if ('inert' in el) {
        el.inert = !!value
      } else if (value) {
        el.setAttribute('aria-hidden', 'true')
      } else {
        el.removeAttribute('aria-hidden')
      }
    } catch (e) {
      console.error(e)
    }
  }

  const onTransitionEndHide = (e) => {
    if (e.target !== banner || e.propertyName !== 'transform') return
    banner.hidden = true
    banner.removeEventListener('transitionend', onTransitionEndHide)
  }

  const showBanner = () => {
    banner.hidden = false
    setInert(banner, false)
    banner.offsetHeight
    banner.classList.add('is-visible')
  }

  const hideBanner = () => {
    // 1) если фокус внутри баннера — убрать его, чтобы не попасть под aria-hidden warning
    if (banner.contains(document.activeElement)) {
      document.activeElement.blur()
    }

    // 2) сразу отключаем интерактивность
    setInert(banner, true)

    // 3) запускаем уезд вниз
    banner.classList.remove('is-visible')
    banner.addEventListener('transitionend', onTransitionEndHide)

    // 4) вернуть фокус в «безопасную» область
    document.body.focus({ preventScroll: true })
  }

  if (!getCookie(COOKIE_NAME)) {
    setTimeout(showBanner, 100)
  } else {
    banner.hidden = true
    setInert(banner, true)
  }

  closeBtn?.addEventListener('click', () => {
    setCookie(COOKIE_NAME, '1', SIX_MONTHS_SECONDS)
    hideBanner()
  })
})
